/* Twenty Fall - tf-ui.js (pass nine, 13 Oct 2026)
   Our own component behaviour: overlays (focus trap, Esc, scroll lock, focus
   return), mobile menu sub-panels, mega panel, search suggestions, cart
   drawer (Section Rendering API), quick-add. Dawn's JS is left alone; only
   the storefront cart endpoints are used for commerce. */
(function () {
  'use strict';
  var TF = (window.TF = window.TF || {});
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PANEL_MS = reduced ? 0 : 330;
  var FOCUS = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function visible(el) { return el.getClientRects().length > 0; }
  function nextFrame(fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---- overlays ---------------------------------------------------------- */
  var stack = [];
  var savedY = 0;
  function lock() {
    if (document.documentElement.classList.contains('tf-lock')) return;
    savedY = window.scrollY || window.pageYOffset;
    document.documentElement.classList.add('tf-lock');
    document.body.style.top = -savedY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  }
  function unlock() {
    if (stack.length) return;
    document.documentElement.classList.remove('tf-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedY);
  }
  function open(id, opener) {
    var ov = typeof id === 'string' ? document.getElementById(id) : id;
    if (!ov) return false;
    if (ov.classList.contains('is-open')) return true;
    ov._opener = opener || document.activeElement;
    ov.hidden = false;
    lock();
    stack.push(ov);
    nextFrame(function () { ov.classList.add('is-open'); });
    if (opener && opener.setAttribute) opener.setAttribute('aria-expanded', 'true');
    var panel = ov.querySelector('.tf-ov__panel, .tf-zoom__panel'); if (panel && !panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
    var f = ov.querySelector('[data-tf-autofocus]') || panel || ov.querySelector(FOCUS);
    setTimeout(function () { if (f && stack[stack.length - 1] === ov) f.focus({ preventScroll: true }); }, reduced ? 0 : 80);
    ov.dispatchEvent(new CustomEvent('tf:open'));
    return true;
  }
  function close(ov) {
    if (typeof ov === 'string') ov = document.getElementById(ov);
    if (!ov || !ov.classList.contains('is-open')) return;
    ov.classList.remove('is-open');
    stack = stack.filter(function (x) { return x !== ov; });
    var done = function () {
      ov.hidden = true;
      unlock();
      var op = ov._opener;
      if (op && op.setAttribute) op.setAttribute('aria-expanded', 'false');
      if (op && op.focus) op.focus({ preventScroll: true });
      ov.dispatchEvent(new CustomEvent('tf:close'));
    };
    setTimeout(done, PANEL_MS);
  }
  TF.open = open;
  TF.close = close;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tf-open]');
    if (o) {
      var id = o.getAttribute('data-tf-open');
      if (document.getElementById(id)) { e.preventDefault(); open(id, o); }
      return;
    }
    var c = e.target.closest('[data-tf-close]');
    if (c) { e.preventDefault(); close(c.closest('.tf-ov')); }
  });
  document.addEventListener('keydown', function (e) {
    if (!stack.length) return;
    var ov = stack[stack.length - 1];
    if (e.key === 'Escape') { e.preventDefault(); close(ov); return; }
    if (e.key !== 'Tab') return;
    var els = [].slice.call(ov.querySelectorAll(FOCUS)).filter(visible);
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && (document.activeElement === first || !ov.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !ov.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  /* ---- mobile menu: sliding sub-panels ------------------------------------ */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-tf-sub]');
    if (s) {
      var p = document.getElementById(s.getAttribute('data-tf-sub'));
      if (!p) return;
      p.hidden = false;
      nextFrame(function () { p.classList.add('is-in'); });
      s.setAttribute('aria-expanded', 'true');
      var b = p.querySelector('[data-tf-back]');
      setTimeout(function () { if (b) b.focus({ preventScroll: true }); }, reduced ? 0 : 80);
      return;
    }
    var back = e.target.closest('[data-tf-back]');
    if (back) {
      var panel = back.closest('[data-tf-subpanel]');
      panel.classList.remove('is-in');
      setTimeout(function () { panel.hidden = true; }, PANEL_MS);
      var tr = document.querySelector('[data-tf-sub="' + panel.id + '"]');
      if (tr) { tr.setAttribute('aria-expanded', 'false'); tr.focus({ preventScroll: true }); }
    }
  });
  var menu = document.getElementById('tf-menu');
  if (menu) menu.addEventListener('tf:close', function () {
    menu.querySelectorAll('[data-tf-subpanel]').forEach(function (p) { p.classList.remove('is-in'); p.hidden = true; });
    menu.querySelectorAll('[data-tf-sub]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  });

  /* ---- mega panel ---------------------------------------------------------- */
  (function () {
    var mega = document.querySelector('[data-tf-mega]');
    var trig = document.querySelector('[data-tf-mega-trigger]');
    if (!mega || !trig) return;
    var t;
    function show() {
      clearTimeout(t);
      if (!mega.hidden) return;
      mega.hidden = false;
      nextFrame(function () { mega.classList.add('is-open'); });
      trig.setAttribute('aria-expanded', 'true');
    }
    function hide(now) {
      clearTimeout(t);
      t = setTimeout(function () {
        mega.classList.remove('is-open');
        trig.setAttribute('aria-expanded', 'false');
        setTimeout(function () { if (!mega.classList.contains('is-open')) mega.hidden = true; }, reduced ? 0 : 210);
      }, now ? 0 : 150);
    }
    trig.addEventListener('mouseenter', show);
    trig.addEventListener('mouseleave', function () { hide(false); });
    mega.addEventListener('mouseenter', function () { clearTimeout(t); });
    mega.addEventListener('mouseleave', function () { hide(false); });
    trig.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === 'ArrowDown') && mega.hidden) { e.preventDefault(); show(); var a = mega.querySelector('a'); if (a) setTimeout(function () { a.focus(); }, 60); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mega.hidden) { hide(true); trig.focus(); } });
    document.addEventListener('focusin', function (e) { if (mega.hidden) return; if (!mega.contains(e.target) && e.target !== trig) hide(true); });
    window.addEventListener('scroll', function () { if (!mega.hidden) hide(true); }, { passive: true });
  })();

  /* ---- search: predictive suggestions ------------------------------------- */
  (function () {
    var ov = document.getElementById('tf-search');
    if (!ov) return;
    var input = ov.querySelector('[data-tf-search-input]');
    var res = ov.querySelector('[data-tf-search-results]');
    var idle = ov.querySelectorAll('[data-tf-search-idle]');
    var timer, last = '';
    ov.addEventListener('tf:open', function () { setTimeout(function () { input.focus(); }, reduced ? 0 : 120); });
    function money(s) {
      var n = parseFloat(s); if (isNaN(n)) return '';
      return (TF.currency || '£') + n.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: Number.isInteger(n) ? 0 : 2 });
    }
    function img(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600'; }
    function render(items) {
      if (!items.length) {
        res.innerHTML = '<p class="tf-search__none">Nothing found for "' + esc(last) + '"</p>';
      } else {
        res.innerHTML = items.map(function (p) {
          return '<div class="tf-card"><a class="tf-card__media" href="' + esc(p.url) + '" tabindex="-1">' +
            (p.featured_image && p.featured_image.url ? '<img class="tf-card__img" src="' + esc(img(p.featured_image.url)) + '" alt="" loading="lazy">' : '') +
            '</a><div class="tf-card__info"><a class="tf-card__name" href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + esc(p.title) + '</a>' +
            '<span class="tf-card__price' + (p.available ? '' : ' tf-card__price--so') + '">' + (p.available ? money(p.price) : 'Sold out') + '</span></div></div>';
        }).join('');
      }
      res.hidden = false;
      idle.forEach(function (x) { x.hidden = true; });
    }
    function reset() { res.hidden = true; res.innerHTML = ''; idle.forEach(function (x) { x.hidden = false; }); }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { reset(); return; }
      timer = setTimeout(function () {
        last = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) { if (input.value.trim() !== q) return; render((d.resources && d.resources.results && d.resources.results.products) || []); })
          .catch(function () {});
      }, 250);
    });
    ov.addEventListener('tf:close', function () { input.value = ''; reset(); });
  })();

  /* ---- cart drawer ---------------------------------------------------------- */
  TF.cart = (function () {
    var ov = document.getElementById('tf-cart');
    var busy = false;
    function body() { return ov ? ov.querySelector('[data-tf-cart-body]') : null; }
    function err(msg) { var e = ov ? ov.querySelector('[data-tf-cart-err]') : null; if (e) e.textContent = msg || ''; }
    function refreshPage() {
      var cp = document.querySelector('[data-tf-cart-page]');
      if (!cp) return Promise.resolve();
      var sid = cp.closest('.shopify-section').id.replace('shopify-section-', '');
      return fetch(window.location.pathname + '?section_id=' + sid, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) { var doc = new DOMParser().parseFromString(html, 'text/html'); var np = doc.querySelector('[data-tf-cart-page]'); var op = document.querySelector('[data-tf-cart-page]'); if (np && op) op.replaceWith(np); });
    }
    function refresh() {
      if (!ov) return refreshPage();
      return refreshPage().then(function () { return fetch(window.location.pathname + '?section_id=tf-cart-drawer', { headers: { Accept: 'text/html' } }); })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nb = doc.querySelector('[data-tf-cart-body]');
          var ob = body();
          if (nb && ob) ob.replaceWith(nb);
          var n = nb ? nb.getAttribute('data-tf-count') : null;
          if (n !== null) document.querySelectorAll('[data-tf-bag-count]').forEach(function (el) { el.textContent = n; });
          document.dispatchEvent(new CustomEvent('tf:cart', { detail: { count: n } }));
        });
    }
    function add(data) {
      if (busy) return Promise.resolve();
      busy = true;
      if (ov) ov.classList.add('is-busy');
      var opts = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
      if (data instanceof FormData) { opts.body = data; }
      else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify({ items: [data] }); }
      return fetch('/cart/add.js', opts)
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j.status && j.description) throw new Error(j.description); if (j.message && !j.items && !j.id) throw new Error(j.message); return refresh(); })
        .then(function () { err(''); if (ov) open(ov); })
        .catch(function (e) { if (ov) open(ov); err(e.message || 'Could not add to bag'); })
        .then(function () { busy = false; if (ov) ov.classList.remove('is-busy'); });
    }
    function change(key, qty) {
      busyRoot(true);
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (j) { var msg = (j && j.status && (j.description || j.message)) ? (j.description || j.message) : ''; document.querySelectorAll('[data-tf-cart-err]').forEach(function (e) { e.textContent = msg; }); return refresh().then(function () { document.querySelectorAll('[data-tf-cart-err]').forEach(function (e) { e.textContent = msg; }); }); })
        .then(function () { busyRoot(false); }, function () { busyRoot(false); });
    }
    function inCartRoot(el) { return el.closest('#tf-cart, [data-tf-cart-page]'); }
    function busyRoot(on) { var cp = document.querySelector('[data-tf-cart-page]'); if (cp) cp.classList.toggle('is-busy', on); if (ov) ov.classList.toggle('is-busy', on); }
    if (ov || document.querySelector('[data-tf-cart-page]')) {
      document.addEventListener('click', function (e) {
        if (!inCartRoot(e.target)) return;
        var m = e.target.closest('[data-tf-qty-minus],[data-tf-qty-plus]');
        if (m) {
          var w = m.closest('[data-tf-qty]'); var inp = w.querySelector('input');
          var q = (parseInt(inp.value, 10) || 0) + (m.hasAttribute('data-tf-qty-plus') ? 1 : -1);
          change(w.getAttribute('data-tf-qty'), Math.max(0, q));
          return;
        }
        var r = e.target.closest('[data-tf-remove]');
        if (r) { change(r.getAttribute('data-tf-remove'), 0); return; }
        var a = e.target.closest('[data-tf-disc-apply]');
        if (a) {
          var di = a.closest('form').querySelector('[data-tf-disc-input]'); var code = (di.value || '').trim();
          if (!code) return;
          try { sessionStorage.setItem('tfOpenCart', '1'); } catch (x) {}
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
        }
      });
      document.addEventListener('change', function (e) {
        if (!inCartRoot(e.target)) return;
        var inp = e.target.closest('[data-tf-qty-input]');
        if (inp) change(inp.closest('[data-tf-qty]').getAttribute('data-tf-qty'), Math.max(0, parseInt(inp.value, 10) || 0));
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.closest('[data-tf-disc-input]') && inCartRoot(e.target)) { e.preventDefault(); var b = e.target.closest('form').querySelector('[data-tf-disc-apply]'); if (b) b.click(); }
      });
      var opened = false;
      if (ov) ov.addEventListener('tf:open', function () { if (!opened) { opened = true; refresh(); } });
      try { if (sessionStorage.getItem('tfOpenCart')) { sessionStorage.removeItem('tfOpenCart'); setTimeout(function () { open(ov); }, 200); } } catch (x) {}
    }
    return { add: add, refresh: refresh, change: change };
  })();

  /* ---- quick-add on cards --------------------------------------------------- */
  function closeQuickAdds(except) {
    document.querySelectorAll('[data-tf-qa].is-open').forEach(function (x) {
      if (x === except) return;
      x.classList.remove('is-open');
      var s = x.querySelector('[data-tf-qa-sizes]'); if (s) setTimeout(function () { s.hidden = true; }, reduced ? 0 : 210);
      var o = x.querySelector('[data-tf-qa-open]'); if (o) o.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tf-qa-open]');
    if (o) {
      e.preventDefault();
      var qa = o.closest('[data-tf-qa]'); var s = qa.querySelector('[data-tf-qa-sizes]');
      var openIt = !qa.classList.contains('is-open');
      closeQuickAdds(qa);
      if (openIt) {
        s.hidden = false;
        nextFrame(function () { qa.classList.add('is-open'); });
        o.setAttribute('aria-expanded', 'true');
        var fb = s.querySelector('button:not([disabled])'); if (fb) fb.focus({ preventScroll: true });
      } else { closeQuickAdds(); }
      return;
    }
    var a = e.target.closest('[data-tf-qa-add]');
    if (a) {
      e.preventDefault();
      a.classList.add('is-busy');
      var d = { id: parseInt(a.getAttribute('data-tf-qa-add'), 10), quantity: 1 };
      var plan = a.getAttribute('data-tf-plan');
      if (plan) { d.selling_plan = parseInt(plan, 10); d.properties = { _selling_plan_id: plan, _purchase_type: 'NM-preorder', 'PN-Note': 'Pre Order Item' }; }
      TF.cart.add(d).then(function () { a.classList.remove('is-busy'); closeQuickAdds(); });
      return;
    }
    if (!e.target.closest('[data-tf-qa]')) closeQuickAdds();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !stack.length) closeQuickAdds(); });

  /* ---- collection: sort menu, density, load more, filter live count -------- */
  (function () {
    var col = document.querySelector('[data-tf-collection], [data-tf-search-page]');
    if (!col) return;
    var grid = col.querySelector('[data-tf-grid]');
    var mq = window.matchMedia('(max-width: 749px)');
    function densKey() { return mq.matches ? 'tf-dens-m' : 'tf-dens-d'; }
    function applyDens(n) {
      grid.className = grid.className.replace(/\btf-dens-\d\b/g, '').trim();
      grid.classList.add('tf-dens-' + n);
      col.querySelectorAll('[data-tf-dens]').forEach(function (b) {
        var mine = mq.matches ? b.classList.contains('tf-dens2__m') : b.classList.contains('tf-dens2__d');
        b.setAttribute('aria-pressed', mine && b.getAttribute('data-tf-dens') === String(n) ? 'true' : 'false');
      });
    }
    var saved = null; try { saved = localStorage.getItem(densKey()); } catch (x) {}
    applyDens(saved || (mq.matches ? 2 : 4));
    col.addEventListener('click', function (e) {
      var d = e.target.closest('[data-tf-dens]');
      if (d) { applyDens(d.getAttribute('data-tf-dens')); try { localStorage.setItem(densKey(), d.getAttribute('data-tf-dens')); } catch (x) {} return; }
      var so = e.target.closest('[data-tf-sort-open]');
      if (so) { var l = so.nextElementSibling; var openIt = l.hidden; l.hidden = !openIt; so.setAttribute('aria-expanded', openIt ? 'true' : 'false'); return; }
      var more = e.target.closest('[data-tf-more]');
      if (more) {
        e.preventDefault();
        more.classList.add('is-busy');
        var url = new URL(more.href, location.href); url.searchParams.set('section_id', col.closest('.shopify-section').id.replace('shopify-section-', ''));
        fetch(url.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ng = doc.querySelector('[data-tf-grid]'); var nm = doc.querySelector('[data-tf-more]'); var ns = doc.querySelector('[data-tf-shown]');
          if (ng) [].slice.call(ng.children).forEach(function (li) { grid.appendChild(li); });
          var wrap = col.querySelector('[data-tf-more-wrap]');
          if (ns && wrap.querySelector('[data-tf-shown]')) wrap.querySelector('[data-tf-shown]').textContent = ns.textContent;
          if (nm) { more.href = nm.href; more.classList.remove('is-busy'); } else { more.remove(); }
          if (ng) grid.setAttribute('data-tf-page', ng.getAttribute('data-tf-page'));
          if (history.replaceState) { url.searchParams.delete('section_id'); history.replaceState(null, '', url.toString()); }
        }).catch(function () { more.classList.remove('is-busy'); });
      }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-tf-sort]')) col.querySelectorAll('.tf-sort__list').forEach(function (l) { l.hidden = true; var b = l.previousElementSibling; if (b) b.setAttribute('aria-expanded', 'false'); }); });
    /* filter drawer: live count via the Section Rendering API, price slider sync */
    var form = document.querySelector('[data-tf-filter-form]');
    if (!form) return;
    var countEl = form.querySelector('[data-tf-filter-count]'); var timer;
    function liveCount() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var fd = new FormData(form); var params = new URLSearchParams();
        fd.forEach(function (v, k) { if (v !== '' && v !== null) params.append(k, v); });
        params.set('section_id', col.closest('.shopify-section').id.replace('shopify-section-', ''));
        fetch((col.getAttribute('data-tf-url') || window.location.pathname) + '?' + params.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var c = doc.querySelector('[data-tf-collection]'); if (c && countEl) countEl.textContent = c.getAttribute('data-tf-total');
        }).catch(function () {});
      }, 250);
    }
    form.addEventListener('change', liveCount);
    form.addEventListener('input', function (e) { if (e.target.closest('[data-tf-price]')) liveCount(); });
    var pr = form.querySelector('[data-tf-price]');
    if (pr) {
      var lo = pr.querySelector('[data-tf-price-lo]'), hi = pr.querySelector('[data-tf-price-hi]'), fmin = pr.querySelector('[data-tf-price-min]'), fmax = pr.querySelector('[data-tf-price-max]'), fill = pr.querySelector('[data-tf-price-fill]'), max = parseFloat(pr.getAttribute('data-max')) || 1;
      function paint() { var a = parseFloat(lo.value), b = parseFloat(hi.value); fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%'; }
      lo.addEventListener('input', function () { if (+lo.value > +hi.value) lo.value = hi.value; fmin.value = +lo.value > 0 ? lo.value : ''; paint(); });
      hi.addEventListener('input', function () { if (+hi.value < +lo.value) hi.value = lo.value; fmax.value = +hi.value < max ? hi.value : ''; paint(); });
      fmin.addEventListener('change', function () { lo.value = fmin.value || 0; paint(); });
      fmax.addEventListener('change', function () { hi.value = fmax.value || max; paint(); });
      paint();
    }
  })();

  /* ---- inline tabs from accordions (desktop) -------------------------------- */
  function tabsFrom(root) {
    if (!root || root.dataset.tfTabbed) return;
    var accs = [].slice.call(root.querySelectorAll(':scope > details'));
    if (accs.length < 2) return;
    root.dataset.tfTabbed = '1';
    var nav = document.createElement('div'); nav.className = 'tf-tabs2__nav'; nav.setAttribute('role', 'tablist');
    var panels = [];
    function select(i) { nav.querySelectorAll('button').forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); b.tabIndex = j === i ? 0 : -1; }); panels.forEach(function (p, j) { p.setAttribute('aria-hidden', j === i ? 'false' : 'true'); }); }
    accs.forEach(function (a, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab'); b.textContent = a.querySelector('summary span').textContent.trim();
      var p = document.createElement('div'); p.className = 'tf-tabs2__panel'; p.setAttribute('role', 'tabpanel'); p.innerHTML = a.querySelector('.tf-acc__b').innerHTML;
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) { if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return; var n = (i + (e.key === 'ArrowRight' ? 1 : accs.length - 1)) % accs.length; select(n); nav.children[n].focus(); });
      nav.appendChild(b); panels.push(p);
    });
    root.appendChild(nav); panels.forEach(function (p) { root.appendChild(p); }); root.classList.add('is-tabbed'); select(0);
  }
  if (window.matchMedia('(min-width: 990px)').matches) tabsFrom(document.querySelector('[data-tf-pacc]'));

  /* ---- product page ------------------------------------------------------------ */
  (function () {
    var pdp = document.querySelector('[data-tf-pdp]');
    if (!pdp) return;
    var dataEl = document.querySelector('[data-tf-product]');
    var P = dataEl ? JSON.parse(dataEl.textContent) : null;
    var form = document.getElementById(pdp.getAttribute('data-tf-form'));
    var vid = form.querySelector('[data-tf-vid]'), plan = form.querySelector('[data-tf-plan]'), planProp = form.querySelector('[data-tf-plan-prop]');
    var atc = form.querySelector('[data-tf-atc]'), atcLabel = form.querySelector('[data-tf-atc-label]'), errEl = form.querySelector('[data-tf-form-err]');
    var sbar = document.querySelector('[data-tf-sbar]'), sbarBtn = sbar && sbar.querySelector('[data-tf-sbar-btn]'), sbarLabel = sbar && sbar.querySelector('[data-tf-sbar-label]'), sbarPrice = sbar && sbar.querySelector('[data-tf-sbar-price]');
    var lead = document.querySelector('[data-tf-lead]');
    var atcText = (atcLabel && atc && !atc.disabled) ? atcLabel.textContent : 'Add to bag';
    var selected = P ? P.options.map(function (o, i) { var pressed = pdp.querySelector('[data-tf-opt="' + i + '"] [aria-pressed="true"]'); return pressed ? pressed.getAttribute('data-tf-val') : null; }) : [];
    function find(sel) { if (P.variants.length === 1) return P.variants[0]; return P.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }); }
    function availableWith(i, val) { var s = selected.slice(); s[i] = val; return P.variants.some(function (v) { return v.available && v.options.every(function (o, j) { return j === i ? o === val : (s[j] === null || o === s[j]); }); }); }
    function paint() {
      if (!P) return;
      P.options.forEach(function (o, i) {
        pdp.querySelectorAll('[data-tf-opt="' + i + '"] [data-tf-val]').forEach(function (b) {
          var val = b.getAttribute('data-tf-val');
          b.setAttribute('aria-pressed', val === selected[i] ? 'true' : 'false');
          b.classList.toggle('is-off', !availableWith(i, val));
        });
        var ov = pdp.querySelector('[data-tf-opt-val="' + i + '"]'); if (ov) ov.textContent = selected[i] || '';
      });
      document.querySelectorAll('[data-tf-sbar-val], [data-tf-sg-val]').forEach(function (b) { var val = b.getAttribute('data-tf-sbar-val') || b.getAttribute('data-tf-sg-val'); b.setAttribute('aria-pressed', val === selected[0] ? 'true' : 'false'); b.classList.toggle('is-off', !availableWith(0, val)); });
      var v = find(selected);
      var cur = pdp.querySelector('[data-tf-price-cur]'), was = pdp.querySelector('[data-tf-price-was]');
      if (v) {
        vid.value = v.id;
        if (plan && planProp) { if (v.plan) { plan.value = v.plan; plan.disabled = false; planProp.value = v.plan; planProp.disabled = false; } else { plan.disabled = true; planProp.disabled = true; } }
        if (cur) cur.textContent = v.price_f;
        if (was) { if (v.was_f) { was.textContent = v.was_f; was.hidden = false; } else { was.hidden = true; } }
        if (sbarPrice) sbarPrice.textContent = v.price_f;
        var ok = v.available;
        if (atc) { atc.disabled = !ok; atcLabel.textContent = ok ? atcText : 'Sold out'; }
        if (sbarBtn) { sbarBtn.disabled = !ok; sbarLabel.textContent = ok ? atcText : 'Sold out'; }
        if (lead) lead.hidden = !(v.plan || P.preorderTag);
        if (v.media) { var fig = pdp.querySelector('[data-media-id="' + v.media + '"]'); if (fig && window.matchMedia('(max-width: 989px)').matches) fig.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduced ? 'auto' : 'smooth' }); }
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      } else {
        if (atc) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; }
        if (sbarBtn) { sbarBtn.disabled = true; sbarLabel.textContent = 'Unavailable'; }
      }
      markSizeGuide();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tf-val], [data-tf-sbar-val], [data-tf-sg-val]');
      if (!b || !P) return;
      var opt = b.closest('[data-tf-opt]'); var i = opt ? parseInt(opt.getAttribute('data-tf-opt'), 10) : 0;
      selected[i] = b.getAttribute('data-tf-val') || b.getAttribute('data-tf-sbar-val') || b.getAttribute('data-tf-sg-val');
      paint();
    });
    paint();
    /* label truce: two apps rewrite the add button at runtime; keep ours and mirror it to the sticky bar */
    if (atc && window.MutationObserver) {
      var want = function () { return atc.disabled ? atcLabel.textContent : atcText; };
      var mo = new MutationObserver(function () { var w = want(); if (atc.textContent.trim() !== w.trim()) { atc.innerHTML = ''; atc.appendChild(atcLabel); atcLabel.textContent = w; } if (sbarLabel && sbarLabel.textContent !== atcLabel.textContent) sbarLabel.textContent = atcLabel.textContent; });
      mo.observe(atc, { childList: true, characterData: true, subtree: true });
    }
    /* add to bag: our form, posted as FormData so the pre-order app's injected fields travel with it */
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !f.matches || !f.matches('[data-tf-form-el]')) return;
      form = f;
      if (e.defaultPrevented) return; /* an app (Mageworx validation) already took this submit */
      e.preventDefault();
      atc = curAtc() || atc; atcLabel = atc && (atc.querySelector('[data-tf-atc-label]') || atcLabel);
      if (atc && atc.disabled && !(sbarBtn && !sbarBtn.disabled)) return;
      errEl.textContent = '';
      var fd = new FormData(form);
      [atc, sbarBtn].forEach(function (b) { if (b) b.classList.add('is-busy'); });
      TF.cart.add(fd).then(function () { [atc, sbarBtn].forEach(function (b) { if (b) b.classList.remove('is-busy'); }); });
    });
    /* sticky bar: only while the inline button is out of view. No node references are held: the pre-order app
       can replace the button (and the form) after load, so the current button is re-queried on every check. */
    function curAtc() { var all = [].slice.call(document.querySelectorAll('[data-tf-form-el] [data-tf-atc]')); return all.filter(function (b) { return b.offsetParent !== null; })[0] || all[0] || null; }
    if (sbar) {
      var syncBar = function () {
        var b = curAtc(); if (!b) { sbar.classList.remove('is-on'); return; }
        var r = b.getBoundingClientRect(); var out = r.height > 0 && (r.bottom < 0 || (document.querySelector('[data-tf-mto]') && r.top > innerHeight));
        sbar.classList.toggle('is-on', out);
      };
      var raf = null;
      window.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; syncBar(); }); }, { passive: true });
      window.addEventListener('resize', syncBar);
      [0, 500, 1500, 3000, 6000].forEach(function (ms) { setTimeout(syncBar, ms); });
      if (window.MutationObserver) new MutationObserver(function () { if (!syncBar._t) syncBar._t = setTimeout(function () { syncBar._t = null; syncBar(); }, 60); }).observe(document.body, { childList: true, subtree: true });
    }
    if (sbar && window.IntersectionObserver) {
      var OVERLAYS = '#PBarNextFrameWrapper, #PBarNextFrame, #preview-bar-iframe, #shopify-pc__banner, .klaviyo-form, [class*="kl-teaser"], [class*="klaviyo-teaser"], #cookie-banner, .cookie-banner';
      function lift() {
        var off = 0;
        document.querySelectorAll(OVERLAYS).forEach(function (el) {
          if (el === sbar || sbar.contains(el)) return;
          var cs = getComputedStyle(el); if (cs.display === 'none' || cs.visibility === 'hidden') return;
          var pos = cs.position; if (pos !== 'fixed' && pos !== 'sticky') return;
          var r = el.getBoundingClientRect(); if (!r.height || r.bottom < innerHeight - 2) return;
          if (r.height > 200 || r.top < innerHeight * 0.5) return; /* a full-screen modal is not a bottom bar */
          off = Math.max(off, Math.round(innerHeight - r.top));
        });
        document.documentElement.style.setProperty('--tf-sbar-off', off + 'px');
      }
      lift(); [300, 1000, 2500, 5000].forEach(function (ms) { setTimeout(lift, ms); });
      window.addEventListener('resize', lift); window.addEventListener('scroll', function () { if (!lift._t) lift._t = setTimeout(function () { lift._t = null; lift(); }, 200); }, { passive: true });
      if (window.MutationObserver) new MutationObserver(function () { if (!lift._m) lift._m = setTimeout(function () { lift._m = null; lift(); }, 100); }).observe(document.body, { childList: true });
    }
    /* Mageworx product options: when the app mounts its container in our form, hide our £0 price line and mirror its
       running total (no "GBP", no .00) into the sticky bar. The app's own mechanics are untouched. */
    (function () {
      var buy = pdp.querySelector('[data-tf-buy]');
      function money(s) { var m = (s || '').match(/£\s?[\d,]+(?:\.\d\d)?/); if (!m) return null; return m[0].replace(/\s/g, '').replace(/\.00$/, ''); }
      function syncMw() {
        var mw = form.querySelector('.mw-apo-container') || pdp.querySelector('.mw-apo-container');
        if (!mw) return;
        if (buy && P && P.variants.length === 1 && P.variants[0].price === 0) buy.classList.add('tf-buy--mw');
        var tot = mw.querySelector('.mw-apo-price-custom .mw-text--style-strong') || mw.querySelector('.mw-apo-price-custom');
        var m = money(tot && tot.textContent);
        if (m && sbarPrice) sbarPrice.textContent = m;
        if (m && buy) { var cur = buy.querySelector('[data-tf-price-cur]'); if (cur && P && P.variants[0].price === 0) cur.textContent = m; }
      }
      syncMw(); [500, 1500, 3000, 6000].forEach(function (ms) { setTimeout(syncMw, ms); });
      if (window.MutationObserver) new MutationObserver(function () { if (!syncMw._t) syncMw._t = setTimeout(function () { syncMw._t = null; syncMw(); }, 80); }).observe(pdp, { childList: true, subtree: true, characterData: true });
    })();
    /* made-to-order page: drive the hidden Mageworx container from our own controls */
    (function () {
      var root = document.querySelector('[data-tf-mto]');
      if (!root) return;
      var steps = root.querySelector('[data-tf-mto-steps]'), lines = root.querySelector('[data-tf-mto-lines]'), totalEl = root.querySelector('[data-tf-mto-total]'), missingEl = root.querySelector('[data-tf-mto-missing]'), thumb = root.querySelector('[data-tf-mto-thumb]');
      var sb = document.querySelector('[data-tf-sbar]'), sbBtn = sb && sb.querySelector('[data-tf-sbar-btn]'), sbPrice = sb && sb.querySelector('[data-tf-sbar-price]');
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
      function pence(s) { var m = (s || '').match(/[+-]?\s*£\s?([\d,]+(?:\.\d\d)?)/); return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0; }
      function gbp(p) { var n = p / 100; return '£' + (Number.isInteger(n) ? n.toLocaleString('en-GB') : n.toLocaleString('en-GB', { minimumFractionDigits: 2 })); }
      function cleanTotal(s) { var m = (s || '').match(/£\s?[\d,]+(?:\.\d\d)?/); return m ? m[0].replace(/\s/g, '').replace(/\.00$/, '') : null; }
      function sized(u, w, h) { if (!u) return ''; var b = u.split('?')[0]; return b + '?width=' + w + '&height=' + h; }
      function stepName(title) { var t = (title || '').toLowerCase(); if (t === 'item' || t === 'style') return 'The piece'; if (t === 'add' || t === 'hood') return 'Collar or hood'; return title; }
      function model() {
        var c = form.querySelector('.mw-apo-container') || root.querySelector('.mw-apo-container');
        if (!c) return null;
        return [].slice.call(c.querySelectorAll('.mw-option')).map(function (o) {
          var sel = o.querySelector('select');
          var title = (o.querySelector('.mw-label .mw-text--style-strong') || {}).textContent || ''; title = title.trim();
          var values = sel ? [].slice.call(sel.options).map(function (op) { return { id: op.value, el: sel, selectVal: op.value, label: op.textContent.trim(), delta: pence(op.textContent), selected: op.selected, image: null }; })
            : [].slice.call(o.querySelectorAll('.mw-option__value')).map(function (v) {
                var inp = v.querySelector('input'); var img = v.querySelector('img');
                return { id: v.dataset.valueId || (inp && inp.id), el: inp, label: ((v.querySelector('.mw-option__value-text') || {}).textContent || (inp && inp.getAttribute('aria-label')) || '').trim(), delta: pence((v.querySelector('.mw-option__price') || {}).textContent), selected: !!(inp && inp.checked), image: img ? (img.currentSrc || img.src || img.getAttribute('data-src')) : null };
              });
          var kind = o.classList.contains('mw-option--type-swatch') ? 'swatch' : (values.some(function (v) { return v.image; }) ? 'cards' : 'text');
          /* the piece is required in our UI even when the app marks it optional */
          return { id: o.dataset.optionId, title: title, name: stepName(title), required: o.classList.contains('mw-option--required') || kind === 'cards', kind: kind, values: values };
        });
      }
      var rendered = false;
      function render(m) {
        var html = '';
        m.forEach(function (o, i) {
          var n = ('0' + (i + 1)).slice(-2);
          html += '<section class="tf-mto__step" data-tf-mto-step="' + esc(o.id) + '"><div class="tf-mto__sh"><h2><i>' + n + '</i>' + esc(o.name) + '</h2>' + (o.required ? '' : '<span>Optional</span>') + '</div>';
          if (o.kind === 'cards') {
            html += '<div class="tf-mto__cards" role="group" aria-label="' + esc(o.name) + '">' + o.values.map(function (v) {
              return '<button type="button" class="tf-mto__card" data-tf-mto-val="' + esc(v.id) + '" aria-pressed="' + (v.selected ? 'true' : 'false') + '"><span class="tf-mto__cardim">' + (v.image ? '<img src="' + esc(sized(v.image, 600, 800)) + '" alt="" loading="lazy" width="600" height="800">' : '') + '</span><span class="tf-mto__cardtx"><span class="tf-mto__cardname">' + esc(v.label) + '</span>' + (v.delta ? '<span class="tf-mto__cardprice">' + gbp(v.delta) + '</span>' : '') + '</span></button>';
            }).join('') + '</div>';
          } else if (o.kind === 'swatch') {
            html += '<div class="tf-mto__sw" role="group" aria-label="' + esc(o.name) + '">' + o.values.map(function (v) {
              return '<button type="button" class="tf-mto__swb" data-tf-mto-val="' + esc(v.id) + '" aria-pressed="' + (v.selected ? 'true' : 'false') + '" aria-label="' + esc(v.label) + '" title="' + esc(v.label) + '">' + (v.image ? '<img src="' + esc(sized(v.image, 160, 160)) + '" alt="" loading="lazy" width="160" height="160">' : '') + '</button>';
            }).join('') + '</div><p class="tf-mto__swname" data-tf-mto-swname="' + esc(o.id) + '"></p>';
          } else {
            html += '<div class="tf-mto__vals" role="group" aria-label="' + esc(o.name) + '">' + o.values.map(function (v) {
              return '<button type="button" class="tf-buy__val" data-tf-mto-val="' + esc(v.id) + '" aria-pressed="' + (v.selected ? 'true' : 'false') + '">' + esc(v.label) + (v.delta ? '<em>+' + gbp(v.delta) + '</em>' : '') + '</button>';
            }).join('') + '</div>';
          }
          html += '</section>';
        });
        steps.innerHTML = html; steps.removeAttribute('aria-busy'); rendered = true;
      }
      function sync() {
        var m = model(); if (!m) return;
        if (!rendered) render(m);
        var missing = [], linesHtml = '', pieceImg = null;
        m.forEach(function (o) {
          var sel = o.values.filter(function (v) { return v.selected; })[0];
          o.values.forEach(function (v) { var b = steps.querySelector('[data-tf-mto-val="' + CSS.escape(String(v.id)) + '"]'); if (b) b.setAttribute('aria-pressed', v.selected ? 'true' : 'false'); });
          var sw = steps.querySelector('[data-tf-mto-swname="' + CSS.escape(String(o.id)) + '"]'); if (sw) sw.innerHTML = sel ? esc(o.title) + ' <span>·</span> ' + esc(sel.label) : '';
          if (o.required && !sel) missing.push(o.name.toLowerCase());
          if (o.kind === 'cards' && sel && sel.image && !pieceImg) pieceImg = sel.image;
          linesHtml += '<li class="' + (sel ? '' : 'is-empty') + '"><span>' + esc(o.name) + '</span><span>' + (sel ? esc(sel.label) + (sel.delta ? ' <b>' + gbp(sel.delta) + '</b>' : '') : (o.required ? 'Choose' : 'None')) + '</span></li>';
        });
        if (lines) lines.innerHTML = linesHtml;
        if (thumb) { var im = thumb.querySelector('img'); if (pieceImg) { im.src = sized(pieceImg, 192, 256); thumb.hidden = false; } else { thumb.hidden = true; } }
        var c = form.querySelector('.mw-apo-container') || root.querySelector('.mw-apo-container');
        var tEl = c && (c.querySelector('.mw-apo-price-custom .mw-text--style-strong') || c.querySelector('.mw-apo-price-custom'));
        var tot = cleanTotal(tEl && tEl.textContent);
        if (!tot) { var sum = 0; m.forEach(function (o) { o.values.forEach(function (v) { if (v.selected) sum += v.delta; }); }); tot = gbp(sum); }
        if (totalEl) totalEl.textContent = tot; if (sbPrice) sbPrice.textContent = tot;
        var ok = missing.length === 0;
        var a = form.querySelector('[data-tf-atc]'); if (a) a.disabled = !ok; if (sbBtn) sbBtn.disabled = !ok;
        if (missingEl) missingEl.textContent = ok ? '' : 'Choose ' + (missing.length > 1 ? missing.slice(0, -1).join(', ') + ' and ' + missing[missing.length - 1] : missing[0]);
      }
      steps.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tf-mto-val]'); if (!b) return;
        var id = b.getAttribute('data-tf-mto-val'); var m = model(); if (!m) return;
        m.forEach(function (o) { o.values.forEach(function (v) {
          if (String(v.id) !== id) return;
          if (v.el && v.el.tagName === 'SELECT') { v.el.value = v.selectVal; v.el.dispatchEvent(new Event('change', { bubbles: true })); }
          else if (v.el && !v.el.checked) { v.el.click(); }
        }); });
        setTimeout(sync, 60); setTimeout(sync, 400);
      });
      /* the mobile bar adds through the in-form button, so the app's own submit handler sees exactly the desktop path */
      if (sbBtn) sbBtn.addEventListener('click', function (e) { e.preventDefault(); var a = form.querySelector('[data-tf-atc]'); if (a && !a.disabled) a.click(); });
      /* measurements post only when filled */
      root.querySelectorAll('[data-tf-mto-meas]').forEach(function (i) { i.disabled = false; i.addEventListener('input', function () { i.disabled = false; }); });
      form.addEventListener('submit', function () { root.querySelectorAll('[data-tf-mto-meas]').forEach(function (i) { if (!String(i.value).trim()) i.disabled = true; }); }, true);
      /* wait for Mageworx to mount, then follow it */
      var tries = 0;
      var wait = setInterval(function () {
        tries++;
        var c = form.querySelector('.mw-apo-container') || root.querySelector('.mw-apo-container');
        if (c && c.querySelector('.mw-option')) {
          clearInterval(wait); c.setAttribute('aria-hidden', 'true'); c.querySelectorAll('input, select, textarea, button, a').forEach(function (el) { el.setAttribute('tabindex', '-1'); }); sync();
          new MutationObserver(function () { if (!sync._t) sync._t = setTimeout(function () { sync._t = null; sync(); }, 80); }).observe(c, { childList: true, subtree: true, attributes: true, characterData: true });
          c.addEventListener('change', function () { setTimeout(sync, 40); });
        } else if (tries > 60) {
          clearInterval(wait);
          var l = root.querySelector('[data-tf-mto-loading]'); if (l) l.textContent = 'Options are unavailable right now. Please try again shortly.';
        }
      }, 250);
    })();
    /* mobile gallery progress */
    var track = pdp.querySelector('[data-tf-pg-track]'), fill = pdp.querySelector('[data-tf-pg-fill]'), curN = pdp.querySelector('[data-tf-pg-cur]');
    var items = [].slice.call(pdp.querySelectorAll('[data-tf-pg-item]'));
    function progress() { if (!track || !items.length) return; var i = Math.round(track.scrollLeft / track.clientWidth); i = Math.max(0, Math.min(items.length - 1, i)); if (fill) fill.style.width = ((i + 1) / items.length * 100) + '%'; if (curN) curN.textContent = i + 1; }
    if (track) { track.addEventListener('scroll', progress, { passive: true }); progress(); }
    /* zoom viewer */
    var zoom = document.getElementById('tf-zoom');
    if (zoom) {
      var ztrack = zoom.querySelector('[data-tf-zoom-track]'), zslides = [].slice.call(zoom.querySelectorAll('[data-tf-zoom-slide]')), zcur = zoom.querySelector('[data-tf-zoom-cur]');
      function zgo(i, instant) { i = (i + zslides.length) % zslides.length; ztrack.scrollTo({ left: i * ztrack.clientWidth, behavior: instant || reduced ? 'auto' : 'smooth' }); }
      function zidx() { return Math.round(ztrack.scrollLeft / ztrack.clientWidth); }
      ztrack.addEventListener('scroll', function () { if (zcur) zcur.textContent = zidx() + 1; }, { passive: true });
      document.addEventListener('click', function (e) {
        var o = e.target.closest('[data-tf-zoom-open]');
        if (o) { e.preventDefault(); var i = parseInt(o.getAttribute('data-tf-zoom-open'), 10) || 0; open(zoom, o); setTimeout(function () { zgo(i, true); if (zcur) zcur.textContent = i + 1; }, 30); return; }
        if (e.target.closest('[data-tf-zoom-prev]')) zgo(zidx() - 1);
        if (e.target.closest('[data-tf-zoom-next]')) zgo(zidx() + 1);
      });
      document.addEventListener('keydown', function (e) { if (zoom.hidden) return; if (e.key === 'ArrowRight') zgo(zidx() + 1); if (e.key === 'ArrowLeft') zgo(zidx() - 1); });
    }
    /* size guide drawer: tabs, units, highlight the selected size column */
    var sg = document.getElementById('tf-sizeguide');
    function markSizeGuide() {
      if (!sg) return;
      sg.querySelectorAll('table').forEach(function (t) {
        var head = t.querySelector('tr'); if (!head) return;
        var cells = [].slice.call(head.children); var col = -1;
        cells.forEach(function (c, i) { c.classList.remove('is-on'); if (selected[0] && c.textContent.trim().toUpperCase() === String(selected[0]).toUpperCase()) col = i; });
        t.querySelectorAll('tr').forEach(function (tr) { [].slice.call(tr.children).forEach(function (c, i) { c.classList.toggle('is-on', i === col && col > -1); }); });
      });
    }
    if (sg) {
      sg.addEventListener('click', function (e) {
        var tb = e.target.closest('[data-tf-sg-tab]');
        if (tb) { var k = tb.getAttribute('data-tf-sg-tab'); sg.querySelectorAll('[data-tf-sg-tab]').forEach(function (x) { x.setAttribute('aria-selected', x === tb ? 'true' : 'false'); }); sg.querySelectorAll('[data-tf-sg-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-tf-sg-panel') !== k; }); return; }
        var u = e.target.closest('[data-tf-unit]');
        if (u) {
          var unit = u.getAttribute('data-tf-unit'); sg.querySelectorAll('[data-tf-unit]').forEach(function (x) { x.setAttribute('aria-pressed', x === u ? 'true' : 'false'); });
          sg.querySelectorAll('table').forEach(function (t) {
            var isCm = /\(cm\)|\bcm\b/i.test(t.textContent) || t.dataset.tfCm === '1';
            if (!isCm) return; t.dataset.tfCm = '1';
            t.querySelectorAll('td, th').forEach(function (c) {
              if (!c.dataset.tfCm) { var m = c.textContent.trim().match(/^(\d+(?:\.\d+)?)(\s*cm)?$/); if (m && c.parentElement.firstElementChild !== c) c.dataset.tfCm = m[1]; else return; }
              var n = parseFloat(c.dataset.tfCm); c.textContent = unit === 'in' ? (Math.round(n / 2.54 * 10) / 10).toString() : n.toString();
            });
            t.querySelectorAll('td:first-child, th:first-child').forEach(function (c) { c.textContent = c.textContent.replace(unit === 'in' ? /\(cm\)/i : /\(in\)/i, unit === 'in' ? '(in)' : '(cm)'); });
          });
        }
      });
      sg.addEventListener('tf:open', markSizeGuide);
    }
  })();
})();
